import Link from 'next/link';

import styled from 'styled-components';

import { UnderConstruction } from '@/shared/components/icons';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 20rem;
  margin: 0 auto;
  padding: 1rem 0 2.5rem 0;
`;

export const Image = styled(UnderConstruction)`
  width: 5rem;
  height: 5rem;
  margin-bottom: 1rem;
`;

export const Title = styled.h2`
  margin-bottom: 0.25rem;
  color: ${({ theme }) => theme.tokens.colors.text[100]};
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.25rem;
`;

export const Description = styled.p`
  margin-bottom: 1.25rem;
  color: ${({ theme }) => theme.tokens.colors.text[300]};
  font-size: 0.8rem;
  font-weight: 500;
  line-height: 1rem;
`;

export const DownloadLink = styled(Link)`
  text-align: center;
  font-size: 0.8rem;
  font-weight: 500;
  line-height: 1rem;
`;
